import { useState, useCallback } from 'react';
import LoginLogo from '@shared/assets/images/mobile_login_background.png';
import { ReactComponent as PonyLogo } from '@shared/assets/images/ponylink-dark-logo.svg';
import eyeClosedIcon from '@shared/assets/images/eye-closed_icon.svg';
import eyeOpenIcon from '@shared/assets/images/eye-open_icon.svg';

import styles from '@pages/login/components/mobile/MobileLogin.module.scss';
export default function MobileLogin({
  companyList,
  isLoading,
  isPending,
  userId,
  passwd,
  companyCode,
  rememberMe,
  onChangeUserId,
  onChangePasswd,
  onChangeCompanyCode,
  onToggleRememberMe,
  onSubmit,
  onFindId,
  onFindPassword,
}) {
  const [showLoginPassword, setShowLoginPassword] = useState(false);

  const toggleLoginPassword = useCallback(() => {
    setShowLoginPassword((prev) => !prev);
  }, []);
  return (
    <div className={styles.page}>
      {/* 상단 비주얼 영역 */}
      <div className={styles.visualWrapper}>
        <img src={LoginLogo} className={styles.visualImg} />
        <div className={styles.overlay} />
      </div>

      {/* 중앙 콘텐츠 영역 (스크롤 / 키보드 대응 영역) */}
      <div className={styles.content}>
        <div className={styles.card}>
          <PonyLogo className={styles.logo} />
          <p className={styles.subTitle}>전자문서 결재 서비스</p>

          <form className={styles.form} onSubmit={onSubmit}>
            <select value={companyCode} onChange={onChangeCompanyCode} disabled={isLoading}>
              <option value="" disabled>
                회사 선택
              </option>
              {companyList.map((company) => (
                <option key={company.companyCode} value={company.companyCode}>
                  {company.company}
                </option>
              ))}
            </select>

            <input value={userId} onChange={onChangeUserId} placeholder="아이디" />
            <div className={styles.passwordWrapper}>
              <input
                type={showLoginPassword ? 'text' : 'password'}
                value={passwd}
                onChange={onChangePasswd}
                placeholder="비밀번호"
                className={styles.passwordInput}
              />
              <button
                type="button"
                className={styles.eyeButton}
                onClick={toggleLoginPassword}
                aria-label={showLoginPassword ? '비밀번호 숨기기' : '비밀번호 보기'}
              >
                <img
                  src={showLoginPassword ? eyeOpenIcon : eyeClosedIcon}
                  alt=""
                  className={styles.eyeIcon}
                />
              </button>
            </div>
            <button type="submit" disabled={isPending || isLoading} className={styles.loginButton}>
              로그인
            </button>

            <label className={styles.keepLogin}>
              <input type="checkbox" checked={rememberMe} onChange={onToggleRememberMe} />
              로그인 유지
            </label>
          </form>
        </div>
      </div>

      {/* 하단 링크 */}
      <div className={styles.links}>
        <button onClick={onFindId}>아이디 찾기</button>
        <span>|</span>
        <button onClick={onFindPassword}>비밀번호 찾기</button>
      </div>
    </div>
  );
}
